import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "store"
import type { ITrainingReport } from "types/trainingReportTypes"

interface TrainingReportState {
  trainingReports: Array<ITrainingReport>
  currentTrainingReport: ITrainingReport | undefined
}

const initialState: TrainingReportState = {
  trainingReports: [] as ITrainingReport[],
  currentTrainingReport: undefined,
}

export const trainingReportSlice = createSlice({
  name: "trainingreport",
  initialState,
  reducers: {
    setTrainingReports: (state, action: PayloadAction<Array<ITrainingReport>>) => {
      state.trainingReports = action.payload
    },
    setCurrentTrainingReport: (state, action: PayloadAction<ITrainingReport>) => {
      state.currentTrainingReport = action.payload
    },
    removeTrainingReport: (state, action: PayloadAction<ITrainingReport>) => {
      var index = state.trainingReports.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.trainingReports.splice(index, 1)
      }
    },
    resetTrainingReport: (state, _action) => {
      state.trainingReports = []
      state.currentTrainingReport = undefined
    },
  },
})

export const {
  setTrainingReports,
  removeTrainingReport,
  setCurrentTrainingReport,
  resetTrainingReport,
} = trainingReportSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectCount = (state: RootState) => state.trainingreport

export default trainingReportSlice.reducer
